@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.categoryTabsWrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 8px;
  margin-top: 16px;

  @include respond-to('max-sm') {
    padding-left: 4px;
  }
}

.styledButtonGroup {
  @include border-radius-r3;

  [data-button-group-item] {
    @include border-radius-r2;
  }
}

.categoryLabel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-left: 8px;
  font-size: 12px;

  &.iconOnly {
    padding-left: 0;
  }
}
